import { graphql } from "gatsby"
import React from "react"
import DatoBlock, { DatoBlockProps } from "./DatoBlock"

//import * as styles from "./DatoPageModules.module.scss"

export type DatoModularContent = DatoBlockProps

type DatoContentModulesProps =
  | Queries.DatoSharedModularContentModulesFragment
  | Queries.DatoPageModulesFragment
  | Queries.DatoProductLandingPageModulesFragment
  | Queries.DatoArticleModulesFragment
  | { modules: Queries.DatoFooterFragment["content"] }

const DatoContentModules = (props: DatoContentModulesProps) => {
  // console.debug("Rendering DatoContentModules", props)

  if (!props.modules) {
    return null
  }

  return props.modules.map(module => {
    return module ? <DatoBlock key={module.key} {...module} /> : null
  })
}

export default DatoContentModules

/**
 * Eri sivujen mahdolliset modular contentit + shared modular content
 * Yritetään pitää listat aakkosjärjestyksessä
 */
export const query = graphql`
  fragment DatoSharedModularContentModules on DatoCmsSharedModularContent {
    modules {
      ... on Node {
        key: id
        __typename
      }
      ...DatoApplicationDownload
      ...DatoContactCollectionRef
      ...DatoContactLocationBlock
      ...DatoContactPersons
      ...DatoCtaToArticle
      ...DatoCtaToExternalUrl
      #...DatoCtaToExternalUrlRef
      ...DatoCtaToPage
      ...DatoCtaRef
      ...DatoCtaToProduct
      ...DatoCtaToProductFinder
      ...DatoExternalVideo
      ...DatoFAQ
      ...DatoForm
      ...DatoHighlightToArticle
      ...DatoHighlightToExternalUrl
      ...DatoHighlightToPage
      ...DatoHighlightToProduct
      ...DatoHighlightToProductFinder
      ...DatoIframeBlock
      ...DatoImageGallery
      ...DatoLatestArticles
      ...DatoMediaBlock
      ...DatoMediaWithText
      #...DatoModularContentRef
      ...DatoNumberFacts
      ...DatoPickedArticles
      ...DatoProductFilter
      ...DatoProductFinderLinkBar
      ...DatoProductFinderTabs
      ...DatoSaunaCalculatorBlock
      #...DatoTabularContent
      ...DatoTextBlock
      ...DatoTileGrid
      ...DatoVideoWithText
      #...DatoTypeform # not enabled for lack of content => GraphQL error
      ...DatoKlaviyoFormEmbed
      ...DatoLeadooDynamicEmbedding
    }
  }
  fragment DatoPageModules on DatoCmsPage {
    modules {
      ... on Node {
        key: id
        __typename
      }
      ...DatoApplicationDownload
      ...DatoArticleFinder
      ...DatoBrochureListBlock
      ...DatoContactCollectionRef
      ...DatoContactLocationBlock
      ...DatoContactPersons
      ...DatoCtaToArticle
      ...DatoCtaToExternalUrl
      #...DatoCtaToExternalUrlRef
      ...DatoCtaToPage
      ...DatoCtaRef
      ...DatoCtaToProduct
      ...DatoCtaToProductFinder
      ...DatoDealerFinder
      ...DatoExternalVideo
      ...DatoFAQ
      ...DatoForm
      ...DatoHighlightToArticle
      ...DatoHighlightToExternalUrl
      ...DatoHighlightToPage
      ...DatoHighlightToProduct
      ...DatoHighlightToProductFinder
      ...DatoIframeBlock
      ...DatoImageGallery
      ...DatoLatestArticles
      ...DatoMediaBlock
      ...DatoMediaWithText
      ...DatoModularContentRef
      ...DatoNumberFacts
      ...DatoPickedArticles
      ...DatoProductFilter
      ...DatoProductFinderLinkBar
      ...DatoProductFinderTabs
      ...DatoSaunaCalculatorBlock
      ...DatoSaunaPlannerBlock
      ...DatoTabularContent
      ...DatoTextBlock
      ...DatoTileGrid
      ...DatoVideoWithText
      ...DatoProductFilesList
      ...DatoTypeform # not enabled for lack of content or not in model validation rules => GraphQL error
      ...DatoKlaviyoFormEmbed
      ...DatoLeadooDynamicEmbedding
    }
  }

  fragment DatoProductLandingPageModules on DatoCmsProductLandingPage {
    modules {
      ... on Node {
        key: id
        __typename
      }
      ...DatoApplicationDownload
      ...DatoContactCollectionRef
      ...DatoContactLocationBlock
      ...DatoContactPersons
      ...DatoCtaToArticle
      ...DatoCtaToExternalUrl
      #...DatoCtaToExternalUrlRef
      ...DatoCtaToPage
      ...DatoCtaRef
      ...DatoCtaToProduct
      ...DatoCtaToProductFinder
      ...DatoDealerFinder
      ...DatoExternalVideo
      ...DatoFAQ
      #...DatoForm
      ...DatoHighlightToArticle
      ...DatoHighlightToExternalUrl
      ...DatoHighlightToPage
      ...DatoHighlightToProduct
      ...DatoHighlightToProductFinder
      ...DatoIframeBlock
      ...DatoImageGallery
      ...DatoLatestArticles
      ...DatoMediaBlock
      ...DatoMediaWithText
      ...DatoModularContentRef
      ...DatoNumberFacts
      ...DatoPickedArticles
      ...DatoProductFilter
      ...DatoProductFinderLinkBar
      ...DatoProductFinderTabs
      ...DatoSaunaCalculatorBlock
      ...DatoSaunaPlannerBlock
      ...DatoTabularContent
      ...DatoTextBlock
      ...DatoTileGrid
      ...DatoVideoWithText
      ...DatoTypeform
      ...DatoKlaviyoFormEmbed
      ...DatoLeadooDynamicEmbedding
    }
  }
  fragment DatoArticleModules on DatoCmsArticle {
    modules {
      ... on Node {
        key: id
        __typename
      }
      ...DatoApplicationDownload
      ...DatoContactCollectionRef
      ...DatoContactLocationBlock
      ...DatoContactPersons
      ...DatoCtaToArticle
      ...DatoCtaToExternalUrl
      #...DatoCtaToExternalUrlRef
      ...DatoCtaToPage
      ...DatoCtaRef
      ...DatoCtaToProduct
      ...DatoCtaToProductFinder
      ...DatoExternalVideo
      ...DatoFAQ
      #...DatoForm
      #...DatoHighlightToArticle
      #...DatoHighlightToPage
      #...DatoHighlightToProduct
      #...DatoHighlightToProductFinder
      ...DatoIframeBlock
      ...DatoImageGallery
      ...DatoLatestArticles
      ...DatoMediaBlock
      ...DatoMediaWithText
      ...DatoModularContentRef
      ...DatoNumberFacts
      ...DatoPickedArticles
      ...DatoProductFilter
      ...DatoProductFinderLinkBar
      #...DatoProductFinderTabs
      #...DatoTabularContent
      ...DatoTextBlock
      ...DatoTileGrid
      ...DatoVideoWithText
      #...DatoTypeform # not enabled for lack of content => GraphQL error
      ...DatoKlaviyoFormEmbed
      ...DatoLeadooDynamicEmbedding
    }
  }
`
